import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {ToastContainerDefaultBox} from "./toast-container.default.box";
import {ToastContainerMrGreenBox} from "./toast-container.mrgreen.box"

export const ToastContainerBox = styledByTheme(ToastContainerDefaultBox)
    .forMrGreen(ToastContainerMrGreenBox)
    .forMrGreenCis(ToastContainerMrGreenBox)
    .apply();
